import React, { useEffect } from "react";
import {
  ListButton,
  SaveButton,
  Toolbar,
  useDataProvider,
  useNotify,
  useRedirect,
  useRefresh,
} from "react-admin";
import { User } from "../../types/user";
import "./index.css";
import { compileBlogPostRequest } from "../../helpers/compileBlogPost";
import { useSelector } from "react-redux";
import { defaultSchema } from "./blog-schema-editor";

const BlogPostToolbar = (props, isCreate, isBlocked) => {
  const location = props.location.pathname.split("/");
  const path = location[location.length - 1];
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const stateApp = useSelector((state) => state);

  const validateSchemaInput = (schemaString: string) => {
    // check <script> tags
    const decoded = schemaString.replace(/\\n/g, "\n").replace(/\\"/g, '"');

    const scriptBlocks = decoded.match(
      /<script\s+type=["']application\/ld\+json["']>([\s\S]*?)<\/script>/g,
    );

    if (!scriptBlocks || scriptBlocks.length === 0) {
      return {
        valid: false,
        error:
          'Missing <script type="application/ld+json"> block. Invalid Blog Schema.',
      };
    }

    for (const block of scriptBlocks) {
      const jsonMatch = block.match(
        /<script\s+type=["']application\/ld\+json["']>([\s\S]*?)<\/script>/,
      );
      if (!jsonMatch) {
        return { valid: false, error: "Malformed <script> block." };
      }

      const jsonPart = jsonMatch[1].trim();

      try {
        JSON.parse(jsonPart);
      } catch (e: any) {
        return {
          valid: false,
          error: `Invalid JSON inside schema block: ${e.message}`,
        };
      }
    }

    return { valid: true, error: "" };
  };

  const handleSave = async (data) => {
    data.isBlocked = isBlocked;
    // data.filesGallery = stateApp.blog.galleryFiles;
    // data.filesGalleryMobile = stateApp.blog.galleryFilesMobile;
    // data.galleryImages = [];
    // data.galleryImagesMobile = [];
    try {
      if (
        (data.publishAt === null || data.publishAt === undefined) &&
        data.status === "publish"
      ) {
        notify("Publish Date is required when status is publish", "error");
        return;
      }
      //check schema data
      if (data.schema) {
        const { valid, error } = validateSchemaInput(data.schema);
        if (!valid) {
          notify(error, "error");
          return;
        }
      } else {
        data = { ...data, schema: defaultSchema };
      }
      const result = isCreate
        ? await dataProvider.create("blogs/cms", {
            data: { ...data, markdown: data.markdown ? data.markdown : "" },
          })
        : await dataProvider.update("blogs/cms", {
            id: props.id,
            data: {
              ...data,
              publishAt: data.publishAt ? data.publishAt : undefined,
              markdown: data.markdown ? data.markdown : "",
            },
            previousData: {} as User,
          });
      if (!result.data) {
        notify("something went wrong", "error");
      }

      const requestProperty = compileBlogPostRequest(data);
      console.log("requestProperty: ", requestProperty);
      if (!requestProperty.images.previewImage) {
        console.log("No preview image — skipping upload");
      } else {
        await dataProvider.storeBlogPostImagesAsync(
          result.data._id,
          requestProperty.images.previewImage,
        );
      }
      // if (
      //   requestProperty.images.galleryImages.length > 0 ||
      //   requestProperty.images.galleryImagesMobile.length > 0
      // ) {
      //   let imagesAssetsResponse =
      //     await dataProvider.storeBlogPostImagesAssetsAsync(
      //       result.data._id,
      //       requestProperty.images.galleryImages,
      //       requestProperty.images.galleryImagesMobile
      //     );
      // }
      notify(`Post ${isCreate ? "saved" : "updated"}`);
      refresh();
      redirect("/blogs");
    } catch (error: any) {
      console.log("ERROR", error);

      notify(error?.data?.error || error?.message || "Unknown error", "error");
    }
    console.log("data", data);
  };

  return (
    <Toolbar
      {...props}
      id={path.length !== 2 ? "toolbar-flex-end" : "hide-toolbar"}
    >
      <SaveButton onSave={(data) => handleSave(data)} className="save-button" />
      <ListButton className="cancel-button" label="Cancel">
        <div>Cancel</div>
      </ListButton>
    </Toolbar>
  );
};

export default BlogPostToolbar;
